<div class="textarea-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Question Text
      </label>
      <input
        #labelInput
        type="text"
        class="config-input label-input"
        [value]="question().labelText"
        (input)="onLabelChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter your question label here...">

      <label class="config-label">Placeholder</label>
      <input
        type="text"
        class="config-input"
        [value]="placeholder"
        (input)="onPlaceholderChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter placeholder text">

      <label class="config-label">Additional Info</label>
      <input
        type="text"
        class="config-input"
        [value]="question().additionalInfo ?? ''"
        (input)="onAdditionalInfoChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter additional information">

      <label class="config-label">Helper Text</label>
      <input
        type="text"
        class="config-input"
        [value]="question().helperText ?? ''"
        (input)="onHelperTextChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter helper text">

      <label class="config-label">Max Characters</label>
      <input
        type="number"
        class="config-input"
        [value]="maxLength ?? ''"
        (input)="onMaxLengthChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter max characters"
        min="1">

      <div class="required-toggle-row">
        <label class="config-label">
          <span class="required-asterisk">*</span>
          Required
        </label>
        <label class="required-toggle-switch">
          <input
            type="checkbox"
            [checked]="question().isRequired"
            (change)="onRequiredToggle()"
            [disabled]="disabled()">
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
  } @else {
    <div class="question-preview">
      <div class="question-label-wrapper">
        <label class="question-label">
          <span [innerHTML]="sanitizeHtml(question().labelText || 'Textarea')"></span>
          @if (question().isRequired) {
            <span class="required-indicator">*</span>
          }
        </label>
        @if (question().additionalInfo) {
          <span class="additional-info" [innerHTML]="sanitizeHtml(question().additionalInfo)"></span>
        }
      </div>
      <div class="question-input-wrapper">
        <textarea
          class="question-textarea"
          [placeholder]="placeholder"
          [disabled]="disabled()"
          [maxLength]="maxLength ?? undefined"></textarea>
        @if (maxLength) {
          <span class="max-length-indicator">Max {{ maxLength }} characters</span>
        }
        @if (question().helperText) {
          <span class="helper-text">{{ question().helperText }}</span>
        }
      </div>
    </div>
  }
</div>

